import './filter-box.scss';

import gzQuickFilterModule from './quick-filter/quick-filter.module';

import * as gzFilterBox from './filter-box.directive';
import gazelleAnalytics from '../../core/analytics/analytics.module';

export default angular.module('gazelle.components.filterBox', [
  'pascalprecht.translate',
  gzQuickFilterModule,
  // Required for angular 1.6 $compile change handled in rhino core.config.js.
  // Consider moving somewhere else
  'rhino.core',
  gazelleAnalytics
])
  .directive(gzFilterBox.name, gzFilterBox.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/filter-box/filter-box.module.js